/** Import modules */
import i18next from "i18next";
import cookies from "js-cookie";
import { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import {
  SUPPORTED_UI_LANGS,
  normalizeLanguage,
  resolveLanguage
} from "../../../Configs/LanguageConfig";

/** Import icons */
import { FaGlobeEurope, FaCaretDown } from "react-icons/fa";

const SESSION_LOCALE_KEY = "i18next";

/**
 * Language selector component
 */
const LanguageSelector = () => {
  const languageNames = {
    lv: "Latviešu",
    en: "English",
    ru: "Русский",
    lt: "Lithuanian",
    ee: "Estonian",
    fi: "Finnish",
    no: "Norwegian",
    se: "Swedish"
  };

  const [language, setLanguage] = useState(() =>
    resolveLanguage({
      search: window.location.search,
      hostname: window.location.hostname,
      cookieLanguage: cookies.get("i18next")
    }).language
  );
  const [dropdown, setDropdown] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  // Sync the language state with i18next changes
  useEffect(() => {
    const handleLanguageChange = (lng) => {
      setLanguage(normalizeLanguage(lng));
    };

    i18next.on("languageChanged", handleLanguageChange);

    return () => {
      i18next.off("languageChanged", handleLanguageChange);
    };
  }, []);

  /** Return component */
  return (
    <div className="language-selector">
      <div
        className="selector"
        onClick={() => setDropdown(!dropdown)}
      >
        <FaGlobeEurope className="hide-768" />
        <span>{language}</span>
        <FaCaretDown />
      </div>

      {dropdown && (
        <div className="dropdown">
          <ul>
            {SUPPORTED_UI_LANGS.map((code) => (
              <li key={code}>
                <button
                  onClick={() => {
                    const searchParams = new URLSearchParams(location.search);
                    searchParams.set("lang", code);
                    sessionStorage.setItem(SESSION_LOCALE_KEY, code);
                    cookies.set("i18next", code);
                    navigate(`${location.pathname}?${searchParams.toString()}`);
                    i18next.changeLanguage(code);
                    setDropdown(false);
                  }}
                  disabled={code === language}
                >
                  {languageNames[code]}
                </button>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};

/** Export component */
export default LanguageSelector;
